import {
	Card,
	makeStyles,
	Tooltip,
	Box,
} from '@material-ui/core';
import { DataGrid } from "@material-ui/data-grid";
import * as dayjs from 'dayjs';
import React from 'react';
import { useActions, useValues } from 'kea';
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { rnotificationlogic } from 'src/store/report';

import NotificationDataDialog from './AddDataDialogs/NotificationDialog';
// import CSVDialog from './CSVDialog';
// import PDFDialog from './PDFDialog';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';


const useStyles = makeStyles({
	root: {
		width: "100%",
		height: '631px'
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)


const columns = [
	{
		name: 'timestamp',
		label: 'Timestamp',
		align: 'left',
		width: 200,
		options: {
			filter: false, customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'type',
		label: 'Type',
		align: 'left',
		width: 200,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'name',
		label: 'Name',
		align: 'left',
		width: 200,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'event',
		label: 'Event',
		align: 'left',
		width: 200,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'timeslot',
		label: 'Timeslot',
		align: 'left',
		width: 300,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'location',
		label: 'Location',
		align: 'left',
		width: 350,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
];

const initialRowsPerPage = 10;
const Milage = () => {
	const classes = useStyles();
	const { report, vehicle, query } = useValues(rnotificationlogic);
	const [data, setData] = React.useState([]);
	const handleAlertValue = (monitor, position) => {
		switch (monitor) {
			case 'service':
				return 'Service Overdue';
			case 'speed':
				return position.speed;
			case 'temperature':
				return position.io.temperature;
			case 'stolen':
				return 'Stolen';
			case 'tamper':
				return 'Tamper';
			default:
				return 'Error';
		}
	}
	React.useEffect(() => {
		if (report.length > 0) {
			console.log(report);
			let newRows = report.map((row, count) => {
				return {
					id: count,
					timestamp: dayjs(row.position.position_timestamp).format('HH:mm:ss  DD MMM YYYY'),
					type: row.alert ? `alert - ${row.alert.condition.monitor}` : 'geofence',
					name: row.alert ? `${row.alert.name}` : `${row.geofence.name}`,
					event: row.alert ? handleAlertValue(row.alert.condition.monitor, row.position) : row.geofence_entry ? 'Entry' : 'Exit',
					location: row.position.address,
					timeslot: row.alert ? 'Not Applicable' : row.geofence_timeslot.map(gt => gt.name).join()
				}
			});
			setData(newRows);
		} else {
			setData([]);
		}
	}, [report]);

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				{/* <br /> */}
				<PrintToolbarPlugin
					title='Notification Report'
					context={{
						head: [['Vehicle Name', 'Registration', 'State', 'Make', 'Model', 'Year', 'Color', 'Start Time', 'End Time']],
						body: [[vehicle?.name, vehicle?.registration_number, vehicle?.registration_state, vehicle?.company, vehicle?.model, vehicle?.year, vehicle?.color, dayjs(query?.start).format('DD-MM-YYYY HH-mm'), dayjs(query?.stop).format('DD-MM-YYYY HH-mm')]]
					}}
					rows={data}
					columns={columns}
					filename={`Notification_Report-${vehicle?.name.replaceAll(' ', '_')}`} />
				<CSVToolbarPlugin
					rows={data}
					columns={columns}
					filename={`Notification_Report-${vehicle?.name.replaceAll(' ', '_')}`}
				/>
				<NotificationDataDialog />
			</span>
	};

	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})
	return (
		<>
			<Box mt={1}>

				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Notification Report" + (vehicle ? `: ${vehicle.name} - ${vehicle.registration_number}` : '')}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</>
	);
};


export default Milage;
